import React, { PureComponent } from 'react'
import { PuffLoader } from 'react-spinners'

export default class Loader extends PureComponent {
  render() {
    return <PuffLoader color = {`#4254FF`} size = {60}/>
  }
}
